import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-register-okta-page',
    templateUrl: './register-okta-page.component.html',
    styleUrls: ['./register-okta-page.component.scss'],
    standalone: false
})
export class RegisterOktaPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
